import { request } from '@umijs/max';
import type { OperatorUser } from '@/services/apiResponse';
import { getNebulithInferenceProApiUrl } from '@/services/util';

export interface SettingOperatorMeta {
  createAt?: string;
  createBy?: string;
  createUser?: OperatorUser;
  updateAt?: string;
  updateBy?: string;
  updateUser?: OperatorUser;
}

export const PLAN_TYPE_TITLE_KEYS = [
  'fixedQuantity',
  'monthly',
  'codingPlan',
  'trial',
  'payAsYouGo',
] as const;

export type PlanTypeTitleKey = (typeof PLAN_TYPE_TITLE_KEYS)[number];

export type PlanTypeTitlePayload = Partial<
  Record<PlanTypeTitleKey, string>
>;

export interface PlanTypeTitleSetting
  extends PlanTypeTitlePayload,
    SettingOperatorMeta {}

/** 查询套餐类型展示名称 */
export async function getPlanTypeTitle(options?: { [key: string]: unknown }) {
  return request<PlanTypeTitleSetting>(
    getNebulithInferenceProApiUrl('setting/get-plan-type-title'),
    {
      method: 'POST',
      data: {},
      ...(options || {}),
    },
  );
}
